<template>
  <div class="page-table-list">
    <div class="content">
      <CCol ref="content" xs="12" lg="12">
        <CCard>
          <CCardBody>
            <v-card class="table-card" shaped>
              <div class="table-container">
                <div class="table-header">
                  <h4 class="table-title">Liste des parcelles</h4>
                </div>
                <div class="table-content">
                  <simple-table></simple-table>
                </div>
              </div>
            </v-card>
          </CCardBody>
        </CCard>
      </CCol>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { SimpleTable } from "@/components"

export default defineComponent({
  name: 'TableList',
  components: {
    SimpleTable
  },
  setup() {
    // Page logic here
    return {
      // Return reactive data, methods, etc.
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/table-list';
</style>
